import { Box, Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { CircularLoader, Download } from '@HomaHealth/ui-component-library';
import {
  BasicTable,
  Button,
  CardComponent,
  PageTitleAndSubTitle,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useEffect, useRef, useState } from 'react';
import { scrollBarStyles } from '../../core-utils/messages/CommonConstants';
import customQueryPageMessages from '../../core-utils/messages/customQueryPageMessages';
import { useStores } from '../../stores';
import QueryIcon from '../../_components/atoms/Icons/QueryIcon';
import Snackbar from '../../_components/atoms/Snackbar';
import Loader from '../../_components/molecules/Loader';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModal';
import { ICohortDetails } from '../../_components/organisms/CreateNewModalCoreComponent';
import { Pagination } from '@mui/material';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import axios from 'axios';
import properties from '../../core-utils/properties';
import { pageScrollDown } from '../SummaryPage';
import { toJS } from 'mobx';
import { downloadCSV } from '../../core-utils/helper-utils/downloadPdfHelper';
import CreateNewQueryModal from '../../_components/organisms/CreateNewQueryModal';
import { useLocation } from 'react-router-dom';
import DateFilter from '../../_components/molecules/DateFilter';
import { observer } from 'mobx-react';
import usePlanDates from '../../core-utils/custom-hooks/PlanDates';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import {
  getColumns,
  getData,
} from '../../core-utils/helper-utils/customQueryPageHelper';
 
import AutocompleteWithCheckBoxes from '../../_components/atoms/Autocomplete';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

interface ITableData {
  heading: string;
  subHeading: string;
  columns: any[];
  data: any[];
  totalCount: number;
}
export interface locationProps {
  state: {
    hideCreateQueryModal?: boolean;
  };
}

const CustomQueryPage = observer(() => {
  //styles
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 0px 63px',
    },
    customQueryRoot: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '63px',
    },
    diseasesTableHeader: {
      height: '48px',
      backgroundColor: '#F2F4FA',
    },
    queryIconGrid: {
      padding: '10px 0px 10px 22px',
    },
    queryDataOverallGrid: {
      marginBottom: '28px',
      height: '44px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #DADEEF',
      width: '1176px',
      borderRadius: '4px',
      flexWrap: 'nowrap',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    queryDataTypography: {
      padding: '10px 10px',
      height: '44px',
      borderRight: '1px solid #DADEEF',
      // width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    queryDataGrid: {
      maxWidth: '400px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      minWidth: '60px',
    },
    editQueryGrid: {
      padding: '10px 40px',
      backgroundColor: '#FFFFFF',
      border: '1px solid #DADEEF',
    },
    tooltip: {
      backgroundColor: patientAccessTheme.palette.grey[900],
      padding: '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
      marginLeft: '50px',
    },
    popper: {
      marginTop: '-20px',
      marginLeft: '-20px',
    },
    overallGridStyles: {
      width: '100%',
      marginRight: '150px',
    },
    tableRoot: {
      height: '530px',
      overflow: 'auto',
      ...scrollBarStyles,
    },
    hide: {
      display: 'none',
    },
    button: {
      width: '160px',
      height: '33px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      color: patientAccessTheme.palette.primary[500],
    },
    tableGrid: {
      marginTop: '11px',
      overflowX: 'auto',
      width: '1130px',
      ...scrollBarStyles,
    },
    searchBox: {
      display: 'flex',
      gap: '1rem',
      margin: '1rem 0',
    },
    flex: {
      display: 'flex',
    },
  });
  const { classes } = useStyles();
  const downloadAnchorRef = useRef<HTMLAnchorElement>(null);
  const location: locationProps = useLocation();
  const [hideCreateQueryModal] = useState(
    location?.state?.hideCreateQueryModal,
  );

  //constants
  const messages = customQueryPageMessages;

  //stores and hooks
  // const membersStore = useStores().membersStore;
  const customQueriesStore = useStores().customQueriesStore;
  const employerGroupStore = useStores().employerGroupStore;
  const quarterlyReportStore = useStores().quaterlyReportStore;
  const loginPageStore = useStores().loginPageStore;
  const {
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    isPlanDatesFetched,
    aggregationParameter,
  } = quarterlyReportStore;

  const { getPlanDates, loading: isPlanDatesLoading } = usePlanDates();
  const payload = useAPIPayload();
  const abortController = new AbortController();
  const [loader] = useState<any>(<Loader />);
  const isFirstRender = useRef<boolean>(true);

  // states
  //Date Constants
  const [, setLoading] = useState<boolean>(false);
  const [isTableLoading, setIsTableLoading] = useState<boolean>(false);
  const [openCohortDetailsModal, setOpenCohortDetailsModal] = useState(false);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });
  const [createQueryModalOpen, setcreateQueryModalOpen] = useState<boolean>(
    !hideCreateQueryModal,
  );

  const [cohortDetailsList, setCohortDetailsList] = useState<ICohortDetails[]>(
    toJS(customQueriesStore.cohortDetailsList) ?? [
      {
        id: 1,
        category: '',
        condition: '',
        property: '',
        results: '',
        dropdownSelectionTypeIndex: 0,
        andOrCondition: 'AND',
      },
    ],
  );
  const [conditionsDetails, setConditionsDetails] = useState<string[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  // cohort related states
  const [memberIds, setMemberIds] = useState<string[]>(
    toJS(customQueriesStore.memberIds) ?? [],
  );
  const [claimIds, setClaimIds] = useState<string[]>(
    toJS(customQueriesStore.claimIds) ?? [],
  );
   
  const [selectedClaimIds, setSelectedClaimIds] = useState<string[]>([]);
  const [startYear, setStartYear] = useState<number>(0);

  // table states and functions
  const [tableData, setTableData] = useState<ITableData>({
    heading: '',
    subHeading: '',
    columns: [],
    data: [],
    totalCount: 0,
  });
  const [totalMemberCount, setTotalMemberCount] = useState<number>(0);

  const getTableData = async (claims: string[]) => {
    setIsTableLoading(true);
    const responseBody = {
      ...payload,
      member_unique_id_list: memberIds,
      feature_list: toJS(customQueriesStore.features),
      pageSize: 10,
      pageNumber: pageNumber - 1,
      claim_id_list: claims,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };

    await axios
      .post(
        properties.aiqBaseUrl +
        properties.customQueryBuild +
        customQueriesStore?.typesAndFeatures[customQueriesStore?.type]?.url,
        responseBody,
      )
      .then((response) => {
        const responseData = response?.data?.response;
        tableData.heading = responseData?.heading;
        tableData.subHeading = responseData?.subHeading;
        tableData.totalCount = responseData?.totalCount;
        tableData.columns = getColumns(toJS(customQueriesStore.features));

        tableData.data = getData(
          responseData?.data,
          toJS(customQueriesStore.features),
          loginPageStore.memberIdentification,
        );
        setTableData({
          ...tableData,
        });
        setTotalPages(Math.ceil(responseData?.totalCount / 10));
        setIsTableLoading(false);
      });
  };

  const getTotalMemberCount = async () => {
    setIsTableLoading(true);
    const responseBody = {
      ...payload,
      member_unique_id_list: [],
      feature_list: ['Member ID'],
    };

    await axios
      .post(
        properties.aiqBaseUrl +
        properties.customQueryBuild +
        properties.customQueryMemberDetails,
        responseBody,
      )
      .then((response) => {
        const responseData = response?.data?.response;
        setTotalMemberCount(responseData.totalCount);
      });
    setIsTableLoading(false);
  };

  const handleDownloadCSV = async (
    downloadAnchorRef: React.RefObject<HTMLAnchorElement | null>,
  ) => {
    const url =
      properties.aiqBaseUrl +
      properties.customQueryBuild +
      customQueriesStore?.typesAndFeatures[customQueriesStore?.type]?.url +
      '/csv';
    const responseBody = {
      ...payload,
      member_unique_id_list: memberIds,
      feature_list: toJS(customQueriesStore.features),
      pageSize: tableData.totalCount,
      pageNumber: pageNumber - 1,
      claim_id_list: selectedClaimIds,
      max_claim_date:
        employerGroupStore?.employerGroupResponseData?.max_claim_date,
    };
    downloadCSV(downloadAnchorRef, url, responseBody, 'data.csv');
    handleOpenSnackBar(messages.downloadCSVMessage, 'info', 5000);
  };

  const getClaimIds = async (signal?: AbortSignal) => {
    await axios
      .post(
        properties.aiqBaseUrl +
        properties.customQueryBuild +
        properties.getClaimIds,
        {
          ...payload,
        },
        { signal },
      )
      .then((response) => {
        const responseData = response?.data?.response;

        setClaimIds(responseData);
      });
  };

  // functions

  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const getCohortDetails = async () => {
    await getTotalMemberCount();
    let conditionDetail = '';
    const conditionsDetails: string[] = [];
    cohortDetailsList?.map((detail, index) => {
      conditionDetail = '';
      conditionDetail += detail?.category + ' ' + detail?.condition + ' ';
      if (detail?.property) {
        conditionDetail += detail?.property + ' ';
      } else if (detail?.multipleProperties) {
        conditionDetail +=
          detail?.multipleProperties?.toString()?.replaceAll(',', ' | ') + ' ';
      }
      if (conditionDetail.trim() !== '') {
        conditionsDetails?.push(conditionDetail);
      }
      if (cohortDetailsList?.length - 1 !== index && detail?.andOrCondition) {
        conditionsDetails?.push(detail?.andOrCondition);
      }
    });
    setConditionsDetails(conditionsDetails);

    if (conditionsDetails.length === 0) {
      setMemberIds([]);
      setClaimIds([]);
    }
  };

  const getAllCharts = async () => {
    setLoading(true);
    setCohortDetailsList(cohortDetailsList);
    setMemberIds(memberIds);
    setStartYear(startYear);
    setClaimIds(claimIds);
    await getTableData(selectedClaimIds);
    await getClaimIds();
    setLoading(false);
  };

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    setPageNumber(value);
  };

  useEffect(() => {
    getAllCharts();

    return () => {
      abortController.abort();
    };
  }, [
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    getTableData(selectedClaimIds);
  }, [
    pageNumber,
    incurredStartDate,
    incurredEndDate,
    paidStartDate,
    paidEndDate,
    isIncurredDate,
    isPaidDate,
    aggregationParameter,
  ]);

  useEffect(() => {
    const fetchPlanDates = async () => {
      if (!isPlanDatesFetched) {
        await getPlanDates();
      }
    };
    if (!employerGroupStore?.employerGroupResponseData?.eg_nid[0]) {
      return;
    }
    fetchPlanDates();
  }, [employerGroupStore?.employerGroupResponseData?.eg_nid]);
  return (
    <>
      {isPlanDatesLoading ? (
        loader
      ) : (
        <>
          <div>
            <Grid container className={classes.root}>
              <Grid
                style={{
                  width: '1182px',
                  position: 'relative',
                }}
              >
                <PageTitleAndSubTitle
                  title={messages.TITLE}
                  chip={
                    <Grid className={classes.flex}>
                      <Typography
                        fontSize="17px"
                        lineHeight="21px"
                        textColor={
                          patientAccessTheme.palette.text.mediumemphasis
                        }
                        fontType="semiBold"
                        margin="2px 8px 0px 0px"
                      >
                        for
                      </Typography>
                      <DateFilter />
                    </Grid>
                  }
                  subTitle={
                    createQueryModalOpen
                      ? messages.SUBTITLE1
                      : messages.SUBTITLE
                  }
                  showDownloadButton={false}
                  showQueryDataButton={false}
                  queryButtonText={
                    cohortDetailsList.length > 0 &&
                      cohortDetailsList[0]?.category !== ''
                      ? messages.EDIT_QUERY_DATA
                      : messages.QUERY_BUTTON_TEXT
                  }
                  queryDataAction={() => {
                    setOpenCohortDetailsModal(true);
                  }}
                />

                <a
                  className={classes.hide}
                  href="empty"
                  ref={downloadAnchorRef}
                />
              </Grid>

              <div id="scroll-top-element"></div>
            </Grid>
            {pageScrollDown('scroll-top-element')}
          </div>
          {/* body */}
          {!createQueryModalOpen && (
            <Grid container className={classes.customQueryRoot}>
              {conditionsDetails && conditionsDetails?.length > 0 && (
                <Grid
                  container
                  direction="row"
                  className={classes.queryDataOverallGrid}
                >
                  <Grid className={classes.queryIconGrid}>
                    <QueryIcon />
                  </Grid>
                  {conditionsDetails?.map((detail, index: number) => {
                    return (
                      <Tooltip
                        key={index}
                        arrow={true}
                        placement="bottom-end"
                        classes={{
                          tooltip: classes.tooltip,
                          arrow: classes.arrow,
                          // popper: classes.popper,
                        }}
                        title={
                          <Grid
                            container
                            sx={{
                              flexDirection: 'column',
                            }}
                          >
                            {conditionsDetails?.map((detail, index: number) => {
                              return <Grid key={index}>{detail}</Grid>;
                            })}
                          </Grid>
                        }
                      >
                        <Grid className={classes.queryDataGrid}>
                          <Typography
                            className={classes.queryDataTypography}
                            lineHeight="25px"
                            fontSize="14px"
                            fontType="regular"
                          >
                            {detail}
                          </Typography>
                        </Grid>
                      </Tooltip>
                    );
                  })}
                </Grid>
              )}
              <Grid
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  marginBottom: '29px',
                }}
              >
                {/* Search Functionality yet to complete */}
                <Grid className={classes.searchBox}>
                  <AutocompleteWithCheckBoxes
                    options={claimIds}
                    defaultValue={selectedClaimIds}
                    handleChange={(event: any, value: any, reason: any) => {
                      setSelectedClaimIds(value);

                      if (reason === 'clear') {
                        setSelectedClaimIds([]);
                        getTableData([]);
                      }
                    }}
                    width="1030px"
                    placeholder="Select Claim Ids"
                    disableClearAll={false}
                  />

                  <Button
                    label={'Get Details'}
                    variant="contained"
                    onClick={() => {
                      getTableData(selectedClaimIds);
                      setPageNumber(1);
                    }}
                    width="130px"
                  />
                </Grid>
                <Box style={{ position: 'relative' }}>
                  <CardComponent
                    title={`${tableData.heading} (${tableData.totalCount})`}
                    subTitle={tableData.subHeading}
                    width="1178px"
                    topRightItem={
                      <Button
                        label="Download CSV"
                        variant="outlined"
                        startIcon={<Download />}
                        onClick={() => handleDownloadCSV(downloadAnchorRef)}
                        width="auto"
                      />
                    }
                    body={
                      isTableLoading ? (
                        <CircularLoader />
                      ) : (
                        <Grid className={classes.tableGrid}>
                          <Grid
                            style={{
                              width:
                                tableData.columns?.length > 4
                                  ? `${tableData.columns?.length * 200}px`
                                  : '1130px',
                            }}
                          >
                            <BasicTable
                              columns={tableData.columns}
                              rowsData={tableData.data}
                              isFullTable={true}
                              headerCellHeight="46px"
                              handleHeaderMouseEnter={() => { }}
                              handleHeaderMouseLeave={() => { }}
                              handleOnClick={() => { }}
                            />
                          </Grid>
                          {totalPages > 0 && (
                            <Pagination
                              page={pageNumber}
                              count={totalPages}
                              onChange={handlePageChange}
                              size="small"
                              color="primary"
                              style={{
                                margin: '20px 0px',
                              }}
                            />
                          )}
                        </Grid>
                      )
                    }
                  />
                </Box>
              </Grid>
            </Grid>
          )}
        </>
      )}
      {Object.keys(customQueriesStore.typesAndFeatures).length &&
        createQueryModalOpen && (
          <CreateNewQueryModal
            setOpen={setcreateQueryModalOpen}
            status={'VIEW'}
            hideOnClose={true}
          />
        )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <CohortDetailsModal
        open={openCohortDetailsModal}
        setOpenCohortDetailsModal={setOpenCohortDetailsModal}
        handleClose={function () {
          setOpenCohortDetailsModal(false);
        }}
        title={messages.COHORT_DETAILS.TITLE}
        subTitle={messages.COHORT_DETAILS.SUBTITLE}
        handleSave={getCohortDetails}
        totalResults={totalMemberCount.toString()}
        startDate={
          aggregationParameter === 'paid' ? paidStartDate : incurredStartDate
        }
        endDate={
          aggregationParameter === 'paid' ? paidEndDate : incurredEndDate
        }
        employerGroup={toJS(customQueriesStore.employerGroups).map(
          (item) => item.eg_nid,
        )}
      />
    </>
  );
});
export default CustomQueryPage;
